<script setup>
// core
import {computed, ref} from "vue";
import {useInfiniteScroll} from "@vueuse/core";
import {SUBSCRIPTIONS_PAYMENT_SYSTEMS} from "@/services/Subscriptions/consts";


// icons
import ClockIcon from "@/components/Icons/Table/ClockIcon.vue";
import TrashIcon from "@/components/Icons/Table/TrashIcon.vue";

// helpers
import {conjugationMonth} from "@/helpers/conjugation";

const props = defineProps({
    data: {
        type: Array,
        required: true,
        default: () => []
    },
    system: {
        type: String,
        required: true,
        default: ''
    }
})
const emit = defineEmits(["loadMore", "delete", "viewHistory"]);

const scrollComponent = ref(null);
const isInvoiceSystem = computed(() => props.system === SUBSCRIPTIONS_PAYMENT_SYSTEMS.INVOICE)

useInfiniteScroll(
    scrollComponent,
    () => {
        emit("loadMore");
    },
    {
        distance: 50,
        interval: 300,
    }
);

const getDate = (date) => {
    if (!date) return;

    const dateObj = new Date(date);
    return dateObj.toISOString().slice(0, 10);
}
</script>

<template>
    <table>
        <thead class="thead">
        <tr>
            <th
                v-for="(title, index) in $tm('page.subscriptions.table.headers')"
                :key="index"
                class="th"
            >
                <span class="headed_text">{{ title }}</span>
            </th>
        </tr>
        </thead>
        <tbody class="compact-table" ref="scrollComponent">
        <tr v-for="item in data" :key="item.subscription_id">
            <td class="item-1">
                ${{ item.amount }}
            </td>
            <td class="item-1">
                {{ conjugationMonth(Number(item.period), $t) }}
            </td>
            <td class="item-1">
                {{ getDate(item.start_date) }}
            </td>
            <td class="item-1">
                {{ getDate(item.next_billing_date) }}
            </td>
            <td class="item-1">
                <span :class="item.status">
                    {{ $t(`page.subscriptions.status.${item.status}`) }}
                </span>
            </td>
            <td class="item-1">
                <div class="actions">
                    <ClockIcon @click="$emit('viewHistory', item)"/>
                    <TrashIcon @click="$emit('delete', item.subscription_id)"/>
                </div>
            </td>
        </tr>
        <tr style="border-bottom: none">
            <td :colspan="6">
                <slot name="information_column"/>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<style scoped lang="scss">
@use "@/styles/table.scss";

.item-1 {
    padding: 25px 15px;

    span {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        &.active {
            color: var(--success-color);
        }

        &.cancelled {
            color: var(--danger-color);
        }

        &.suspended {
            color: var(--warning-color);
        }
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        svg {
            cursor: pointer;
        }
    }
}
</style>
